import { ILopActionTypes, eLopActionTypeIds } from "../../action-types/category/ILopActionType";
import { ILopReducer } from "../../reducer-model/category/ILopReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: ILopReducer = {
    status: eReducerStatusBase.is_not_initialization,
    lops: []
}
export const lopReducer = (state: ILopReducer=iniState, action: ILopActionTypes): ILopReducer => {
    switch (action.type) {
        case eLopActionTypeIds.LOAD_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case eLopActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                lops: action.payload
            }
        case eLopActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }

        default:
            return {
                ...state
            };
    }
}